import React, { useState } from 'react';
import ScrollLTR from '../../../../../lms-shared/UI/ScrollLTR';
import classes from './LessonsList.module.css';
import CheckBox from '../../../../../UI/CheckBox';
import warnIcon from '../../../../../../assests/learning-tracking/teams/warn.png'

const LessonsList = ({ lessonsList, changeRange }) => {

    const [selectedLessons, setSelectedLessons] = useState(lessonsList);

    const handleCheckboxChange = (lessonId) => {
        const lessonToUpdate = lessonsList.find(lesson => lesson.id === lessonId);

        if (lessonToUpdate) {
            const selectedIndex = selectedLessons.findIndex(selectedLesson => selectedLesson.id === lessonId);

            if (selectedIndex !== -1) {
                const updatedSelected = [...selectedLessons];
                updatedSelected.splice(selectedIndex, 1);
                setSelectedLessons(updatedSelected);
            }
            else {
                setSelectedLessons(prevSelected => [...prevSelected, lessonToUpdate]);
            }
        }
    };

    return (
        <div>
            <div className={classes.LessonsList}>
                <ScrollLTR>
                    <div className={classes.LessonsListContainer}>
                        {lessonsList && selectedLessons &&
                            lessonsList.map((lesson, index) => (
                                <div className={classes.LessonItem} key={index}>
                                    <CheckBox
                                        checked={selectedLessons.some(selectedLesson => selectedLesson.id === lesson.id)}
                                        onChecked={() => handleCheckboxChange(lesson.id)}
                                        onRemoveChecked={() => handleCheckboxChange(lesson.id)}
                                        value={lesson.id}
                                    >
                                        {lesson.name}
                                    </CheckBox>
                                    {lesson?.hasSubmissions && <img className={classes.WarnIcon} src={warnIcon} alt="icon" />}
                                </div>
                            ))}
                    </div>
                </ScrollLTR>
            </div>
            <div className={classes.Apply} onClick={() => changeRange(selectedLessons)}>החל</div>
        </div>
    );
};

export default LessonsList;